/* SERVICES	*/
import { createAction, createApiAction } from 'store';
import { ISurveyService } from 'models';
import * as types from './ActionTypes';

export const getCategoryList = createApiAction(types.GET_CATEGORY_LIST);
export const getPartnerCategoryList = createApiAction(
	types.GET_PARTNER_CATEGORY_LIST,
);
export const getTemplatePartnerCategories = createApiAction(
	types.GET_SA_TEMPLATE_PARTNER_CATEGORY_LIST,
);
export const getCategoryShortList = createApiAction(
	types.GET_CATEGORY_SHORT_LIST,
);
export const postCategory = createApiAction(types.POST_CATEGORY);

export const postService = createApiAction(types.POST_SERVICE);
export const updateService = createApiAction<
	Partial<ISurveyService> & { templateId?: number; categoryId?: number }
>(types.PATCH_SERVICE);

export const resetServicesError = createAction(types.RESET_SERVICES_ERROR);
export const resetIsServiceCreated = createAction(
	types.RESET_IS_SERVICE_CREATED,
);
export const resetIsCategoryCreated = createAction(
	types.RESET_IS_CATEGORY_CREATED,
);
export const resetPartnerCategoryList = createAction(
	types.RESET_PARTNER_CATEGORY_LIST,
);

export const resetCategoryList = createAction(types.RESET_CATEGORY_LIST);
